import React from 'react'

class RadioButton extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  display() {
    const props = this.props

    return (
      <div className="form-radios">
      {props.values.map((val, index) => {
        return (
          <div key={index} className="form-item form-type-radio">
            <input onChange={props.change} type="radio" id={val+index} name={props.name} value={val} className="form-radio"/>  <label className="option vertical-top" htmlFor={val+index}>{val} </label>
          </div>
        )
      })}
      </div>
    )
  }

  render() {
    return this.display()
  }
}

export default RadioButton
